import { render, staticRenderFns } from "./MemberRenewal.vue?vue&type=template&id=8d36c510"
import script from "./MemberRenewal.vue?vue&type=script&lang=ts"
export * from "./MemberRenewal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports